<template>
  <base-text class="permission-title">
    <base-avatar
      v-if="isInstitution"
      class="permission-avatar"
      inverse
      :size="33"
      rounded-image
      :username="ownerFullName"
      :abbr="abbr"
      background-color="#333333"
    />
    <base-avatar
      v-else
      class="permission-avatar"
      inverse
      username=""
      :abbr="abbr"
      :size="33"
      :img="profilePic"
      rounded-image
      background-color="#333333"
    />
    <div v-if="!noText">
      {{ ownerFullName }}
      {{ $t('folders.detail.ownerSuffix') }}
    </div>
  </base-text>
</template>

<script>
export default {
  name: 'AlbumOwnerIndicator',
  props: {
    ownerFullName: {
      type: String,
      default: '',
    },
    profilePic: {
      type: String,
      default: '',
    },
    isInstitution: {
      type: Boolean,
      default: false,
    },
    abbr: {
      type: String,
      default: '',
    },
    noText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss" scoped>
.permission-avatar {
  margin-right: 8px;
}
.permission-title {
  color: $black;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  overflow: hidden;
  align-items: center;
}
</style>
